import { call, put } from 'redux-saga/effects';

import { initAuth } from 'store/reducers/accounts';
import { startLoading, finishLoading } from 'store/reducers/loading';

export default function createRequestSaga(
  type: string,
  request: any,
  sagaCallback?: any,
) {
  const SUCCESS = `${type}_SUCCESS`;
  const FAILURE = `${type}_FAILURE`;

  return function* (action) {
    yield put(startLoading(type));
    try {
      const { callback, ...kwargs } = action.payload || {};
      const response = yield call(request, kwargs);
      yield put({
        type: SUCCESS,
        payload: response?.data,
        meta: response,
      });
      if (callback) {
        yield callback(response);
      }
      if (sagaCallback) {
        yield* sagaCallback(response);
      }
    } catch (e) {
      if (e?.response?.status === 401) {
        yield put(initAuth());
      }
      yield put({
        type: FAILURE,
        payload: e,
        error: true,
      });
    }
    yield put(finishLoading(type));
  };
}
